import React from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { ColorPicker } from '../../color-picker/color-picker';
import { PopoverDialog } from '../../popover/dialog/popover-dialog.component';
import { usePopoverDialog } from '../../popover/dialog/use-popover-dialog';
import { ActionDropdownChip } from '../atoms/action-dropdown-chip';

const colorPickerActionDivStyle1 = css`
  width: 16px;
  height: 16px;
  border-radius: ${theme.borderRadius.small};
  background: var(--color-picker-action-div-inline-color);
  border: 1px solid ${theme.colors.neutral30};
  margin-right: ${theme.spacing(0.5)};
  transition: 0.2s ease;
`;

const colorPickerActionPopoverDialogStyle2 = css`
  border-radius: ${theme.borderRadius.medium};
`;

type ColorPickerActionProps = Pick<
  React.ComponentProps<typeof ColorPicker>,
  'color' | 'onChange' | 'palette' | 'imageSrc' | 'shouldApply'
> &
  Pick<React.ComponentProps<typeof ActionDropdownChip>, 'showBoxShadow' | 'compact' | 'className'>;

export const ColorPickerAction = ({
  color = '#FFF',
  showBoxShadow = true,
  compact = true,
  className: actionStyle,
  ...rest
}: ColorPickerActionProps) => {
  const { getTriggerProps, getDialogProps, isOpen, close } = usePopoverDialog<HTMLButtonElement>({
    placement: 'bottom-start',
  });

  return (
    <>
      <ActionDropdownChip
        compact={compact}
        {...getTriggerProps()}
        showBoxShadow={showBoxShadow}
        isActive={isOpen}
        isOpen={isOpen}
        className={actionStyle}
      >
        <div
          className={cx('color-action-box', colorPickerActionDivStyle1)}
          style={
            {
              '--color-picker-action-div-inline-color': color,
            } as any
          }
        ></div>
      </ActionDropdownChip>
      <PopoverDialog {...getDialogProps()} className={colorPickerActionPopoverDialogStyle2} returnFocus={false}>
        <ColorPicker syncColor={color} onClick={close} {...rest} />
      </PopoverDialog>
    </>
  );
};
